<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Documentos del Empleado</h4>
                <button ref="closeDocumentsModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form theme-form">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="mb-3">
                                <select class="form-select" v-model="contract_type">
                                    <option v-for="(type, index) in types" :key="index" :value="type.code">{{ type.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="downloadDocument">Descargar Documento</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employees'


export default {
    name: 'employee_contract_modal',
    mixins: [],
    props: {
        
    },
    components: {
        
    },
    data(){
        return{
            showModal: true,
            types: [
                {code: 'personal', name: 'Identificación oficial (STATUS)'},     
                {code: 'address', name: 'Comprobante de domicilio (STATUS)'},
                {code: 'fiscal', name: 'Comprobane de Situación Fiscal (STATUS)'}, 
                {code: 'imss', name: 'Vigencia de derechos o número de IMSS (STATUS)'},
                {code: 'bank', name: 'Carátula de estado de cuenta bancario (STATUS)'}, 
                {code: 'infonavit', name: 'Hoja de retencion del Credito Infonavit o Fonacot (STATUS)'}
            ],
            contract_type: 'contract',
            employee: null
        }
    },
    methods: {
        loadEmployee(employee){
            this.employee = employee;
        },
        async downloadDocument() {
            let response = await ws.downloadDocument(this.employee, this.contract_type);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                window.open(response.data, '_blank');
            }
            else{
                this.$toast.error(response.message);
            }
        },
        closeModal(){
            this.$refs.closeDocumentsModal.click();
        }
    }
}
</script>